module.exports = __webpack_public_path__ + "img/success.1154486c.svg";